<!-- Modals -->
<app-deprecated-modal-form
    #applyTasksModal
    [form]="applyTasksForm"
    [label]="'Apply'"
    (save)="onApplyTaskTemplates(applyTasksForm.getSelectedTaskTemplates())"
    (cancel)="onCancel()"
    headerText="Assign Tasks"
>
    <app-deprecated-apply-tasks
        #applyTasksForm
        [employee]="employee"
        [tasks]="tasks"
        [autoMatchedTaskTemplates]="autoMatchedTaskTemplates"
        [otherTaskTemplates]="otherTaskTemplates"
    ></app-deprecated-apply-tasks>
</app-deprecated-modal-form>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event"></app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content">
            <!--Show terminated empty state if employee is not terminated-->
            <div *ngIf="!employee.terminatedOn" class="nontermination-state">
                <div class="ui segment">
                    <div *ngIf="isAdmin" class="sub header center admin-message">
                        You can apply offboarding tasks to {{ employee.firstName }}'s profile after you have <br />
                        selected their last day of work before termination.
                    </div>

                    <div *ngIf="!isAdmin" class="sub header center non-admin-message">
                        Offboarding Tasks can't be added to {{ employee.firstName }}'s profile until their last day of
                        work is confirmed by the admin.
                    </div>

                    <div *ngIf="isAdmin" class="ui centered header offboard-button">
                        <ui-button type="primary" url="/employees/directory/{{ employee.id }}/terminate">
                            Offboard {{ employee.firstName }}
                        </ui-button>
                    </div>
                </div>
            </div>

            <!--Tasks-->
            <div *ngIf="employee.terminatedOn">
                <div class="tasks" *ngIf="tasks?.length">
                    <!--Incomplete Tasks-->
                    <div
                        class="ui segment"
                        *ngIf="incompleteTasks?.length; else emptyIncompleteTasksState"
                        [class.loading]="isLoadingIncompleteTasks"
                    >
                        <app-segment-header title="Offboarding Tasks">
                            <div class="buttons">
                                <ui-button
                                    (click)="showApplyTasksModal(events.EmployeeProfileOffboardingAddExistingTask)"
                                    type="link"
                                >
                                    Add Existing Task
                                </ui-button>
                                <ui-button (click)="addNewTask()" type="link"> Create New Task </ui-button>
                            </div>
                        </app-segment-header>

                        <div class="tasks-container" #incompleteTasksContainer>
                            <!--Incomplete Task Checklist-->
                            <app-deprecated-task-checklist
                                #incompleteTaskChecklist
                                [employee]="employee"
                                [tasks]="incompleteTasks"
                                (updateTasks)="updateTasks()"
                                (onScroll)="onScrollIncompleteTasksList()"
                                (onLoading)="onIncompleteTaskLoading($event)"
                                (reminded)="onRemind()"
                                (deleted)="onDelete()"
                            ></app-deprecated-task-checklist>
                        </div>
                    </div>
                    <ng-template #emptyIncompleteTasksState>
                        <div class="ui segment">
                            <app-segment-header title="Offboarding Tasks">
                                <div class="buttons">
                                    <ui-button type="link" url="new">Create New Task</ui-button>
                                    <!-- Open Apply Tasks Modal here -->
                                    <ui-button
                                        type="primary"
                                        (click)="showApplyTasksModal(events.EmployeeProfileOffboardingAddExistingTask)"
                                        >Apply Tasks</ui-button
                                    >
                                </div>
                            </app-segment-header>

                            <div class="sub header center emptyText">
                                There are no outstanding tasks for {{ employee.firstName }}
                            </div>
                        </div>
                    </ng-template>

                    <!--Complete Tasks-->
                    <div class="ui segment" [class.loading]="isLoadingCompletedTasks">
                        <app-segment-header title="Completed Offboarding Tasks"></app-segment-header>

                        <ng-container *ngIf="completedTasks?.length; else emptyCompleteTasksState">
                            <div class="tasks-container" #completedTasksContainer>
                                <!--Complete Task Checklist-->
                                <app-deprecated-task-checklist
                                    #completedTaskChecklist
                                    [employee]="employee"
                                    [tasks]="completedTasks"
                                    (updateTasks)="updateTasks()"
                                    (onScroll)="onScrollCompletedTasksList()"
                                    (onLoading)="onCompletedTaskLoading($event)"
                                ></app-deprecated-task-checklist>
                            </div>
                        </ng-container>
                    </div>
                    <ng-template #emptyCompleteTasksState>
                        <div class="emptyText">
                            <div class="sub header center emptyText">
                                No tasks have been completed for {{ employee.firstName }}
                            </div>
                        </div>
                    </ng-template>
                </div>

                <!--If there are no tasks, show empty state-->
                <ng-container class="tasks" *ngIf="!isLoading && tasks && !tasks.length">
                    <ng-container
                        *ngIf="autoMatchedTaskTemplates.length || otherTaskTemplates.length; else noTaskTemplates"
                    >
                        <div class="ui segment">
                            <div class="sub header center emptyTasks">
                                There are {{ autoMatchedTaskTemplates.length }} tasks relevant to
                                {{ employee.firstName }}.
                                <br />
                                Select Apply Tasks to view and apply them here
                            </div>

                            <div class="ui centered header emptyTasksButtons">
                                <ui-button type="link" url="new" class="push">Create New Task</ui-button>
                                <!-- Open Apply Tasks Modal here -->
                                <ui-button type="primary" (click)="showApplyTasksModal(events.OffboardingTaskApply)"
                                    >Apply Tasks</ui-button
                                >
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #noTaskTemplates>
                        <div class="ui segment">
                            <div class="sub header center emptyTasks">
                                There are no tasks relevant to {{ employee.firstName }}.
                                <br />
                                Create a new task and apply them here
                            </div>

                            <div class="ui centered header emptyTasksButtons">
                                <ui-button type="primary" url="new" class="push">Create New Task</ui-button>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>
